import { push } from 'connected-react-router';
import { connect } from 'react-redux';

import { PageTitleBodyAndFooter } from 'src/app/components/Elements/PageTitleBodyAndFooter';
import { home } from 'src/app/router/paths';
import type { Dispatch } from 'src/app/state/store';

import { ButtonContainer, StyledSingleButton } from '../GetStarted/styles';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  redirectHome: () => dispatch(push(home.toPath())),
});

const WaitlistSuccessRenderer = ({ redirectHome }) => {
  return (
    <PageTitleBodyAndFooter
      title={'Thanks for signing up'}
      secondaryText={
        'You’ll be among the first to find out when we are serving your neighborhood. We can’t wait to look after you!'
      }
      tertiaryText={''}
      showInterstitial={false}
    >
      <ButtonContainer>
        <StyledSingleButton size="medium" onClick={redirectHome}>
          Done
        </StyledSingleButton>
      </ButtonContainer>
    </PageTitleBodyAndFooter>
  );
};

export const PromoOnboardingWaitlistSuccess = connect(null, mapDispatchToProps)(WaitlistSuccessRenderer);
